import(/* webpackMode: "eager" */ "/home/runner/_work/booking-engine-page/booking-engine-page/src/app/[locale]/error.js");
